<script>
import iApi from '../_api.js';
import _ from "lodash";

export default {
  name: 'events',

  mixins: [iApi],

  data() {
    return {
      events: null,
      isLoading: true,
    }
  },

  template: `
    <div class="wp-block-dash-public-container" v-bind:class="{'is-loading': isLoading}">

    <div class="wp-block-group has-background alignfull">
      <div class="wp-block-group__inner-container">
        <div v-if="events && events.length > 0" class="list-items alignwide">
          <a
              v-for="event in events"
              v-bind:key="event.id"
              :href="event.id"
              class="list-item">
            <div>
              <h4>{{ event.title }}</h4>
            </div>
            <i class="fas fa-chevron-right"></i>
          </a>
        </div>
        <div v-else>
          <h5 class="aligncenter">There are no active events currently.</h5>
        </div>
      </div>
    </div>

    </div>
  `,

  mounted() {
    this.getEvents();
  },

  methods: {
    getEvents: function () {
      const $this = this;
      const data = {};

      jQuery.when(
          this.callApi('GET', '/events/my', data, function (result) {
            $this.events = _.sortBy(result, 'title');
          }, function (error) {
            $this.isError = true;
            $this.isLoading = false;
          }),
      ).then(function (results) {
        $this.isLoading = false;
      });
    },
  }
}
</script>

<style scoped></style>
